<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.4492 15.9402C4.33512 15.9402 1 12.5957 1 8.47009C1 4.34447 4.33512 1 8.4492 1C12.5633 1 15.8984 4.34447 15.8984 8.47009C15.8984 10.1608 15.3383 11.7204 14.394 12.9723L18.7093 17.2997C19.0972 17.6887 19.0972 18.3193 18.7093 18.7083C18.3214 19.0972 17.6925 19.0972 17.3046 18.7083L12.9961 14.3876C11.7381 15.3611 10.1611 15.9402 8.4492 15.9402ZM8.44932 13.9482C11.4663 13.9482 13.9121 11.4955 13.9121 8.47009C13.9121 5.44464 11.4663 2.99202 8.44932 2.99202C5.43233 2.99202 2.98657 5.44464 2.98657 8.47009C2.98657 11.4955 5.43233 13.9482 8.44932 13.9482Z"
      fill="#999999"
    />
  </svg>
</template>
